import { render } from "./profileInvoicesPage.vue?vue&type=template&id=1f658e5a&ts=true"
import script from "./profileInvoicesPage.vue?vue&type=script&lang=ts"
export * from "./profileInvoicesPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__